import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

interface EposRetailerSelectorProps {
    retailer: string;
    onChange: (retailer: string) => void;
}

export default function EposRetailerSelector({ retailer, onChange }: EposRetailerSelectorProps) {
    return (
        <FormControl size="small" sx={{ minWidth: 210 }}>
            <InputLabel id="epos-retailer-label">Retailer</InputLabel>
            <Select<string>
                labelId="epos-retailer-label"
                label="Retailer"
                value={retailer}
                onChange={event => onChange(event.target.value)}
            >
                <MenuItem value="1">Sainsbury&apos;s</MenuItem>
                <MenuItem value="3">Waitrose</MenuItem>
            </Select>
        </FormControl>
    );
}
